import React, { useState, useCallback } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { tfaRevoke } from '~data/actions/user'

import { Link, useParams, useNavigate } from 'react-router-dom'
import { Helmet } from 'react-helmet'
import { Button, Layout, Text, ButtonRow, Preloader, HeaderTitle as Title, Header } from '~ui';
import { Alert, Error } from '~co/overlay/dialog'

export default function PageAccountTfaRevoke() {
    const { token } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [code, setCode] = useState('')
    const [loading, setLoading] = useState(false)

    const onChangeCodeField = useCallback(e=>setCode(e.target.value), [])

    const onSubmit = useCallback(e=>{
        e.preventDefault()
        setLoading(true)

        dispatch(tfaRevoke(
            { token, code },
            ()=>{
                Alert(t.s('tfaDisabledAlert'))
                navigate('/account')
            },
            e=>{
                setLoading(false)
                Error(e)
            }
        ))
    }, [code, token, navigate])

    return (<>
        <Helmet><title>{t.s('disableTfa')}</title></Helmet>

        <form onSubmit={onSubmit}>
            <Header data-no-shadow>
                <Title>{t.s('disableTfa')}</Title>
            </Header>

            <Layout>
                <Text
                    autoFocus
                    type='text'
                    name='code'
                    disabled={loading}
                    required
                    placeholder={t.s('recoveryCode')}
                    value={code}
                    onChange={onChangeCodeField} />

                <ButtonRow>
                    {loading ? (
                        <Button variant='flat'>
                            <Preloader />
                        </Button>
                    ) : (
                        <Button
                            as='input' 
                            type='submit'
                            variant='primary'
                            value={t.s('disable')}
                            disabled={!code} />
                    )}

                    <Button
                        as={Link}
                        variant='outline'
                        to='/account/login'>
                        {t.s('cancel')}
                    </Button>
                </ButtonRow>
            </Layout>
        </form>
    </>)
}